<template>
    <div class="current-order">
        <v-btn v-if="is_logged_in" class="hidden-sm-and-down"
               @click="dialog = true"
               flat large color="text_navbar">
            <span>Заказ
                <v-divider></v-divider>
                <span class="primary--text">{{order.total | TO_PRICE}}</span>
            </span>
            <v-badge color="primary" right>
                <span slot="badge">{{order_items.length}}</span>
                <v-icon right medium>shopping_cart</v-icon>
            </v-badge>
        </v-btn>
        <v-btn v-if="is_logged_in" class="hidden-md-and-up"
               @click="dialog = true"
               flat color="text_navbar">
           <v-badge color="primary" right>
                <span slot="badge">{{order_items.length}}</span>
                <v-icon left medium>shopping_cart</v-icon>
            </v-badge>
            <br>
            <span class="primary--text mob-price-total">{{order.total | TO_PRICE}}</span>
       </v-btn>

        <v-dialog v-model="dialog_mail_sent" width="600" persistent>
            <v-card>
                <v-card-title class="subheading success lighten-2" primary-title>
                    <v-icon left>how_to_vote</v-icon>
                    <span class="font-weight-medium">Письмо отправлено</span>
                </v-card-title>
                <v-card-text>
                    <p>Заказ отправлен вашему менеджеру.</p>
                    <p>В ближайшее время менеджер свяжется с вами.</p>
                    <v-divider></v-divider>
                    <p>Вы можете просмотреть свои заказы в архиве заказов вашего профиля.</p>
                    <p>Информация о вашем менеджере и его контактные данные находятся в настройках вашего профиля.</p>
                </v-card-text>
                <v-card-actions class="bg_navbar">
                    <v-layout row wrap>
                        <v-flex xs12 md4>
                            <v-btn block color="secondary" flat @click="close_form">
                                Закрыть
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-btn block color="accent" flat @click="close_form" to="/account">
                                <v-icon left>account_box</v-icon>
                                В профиль
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-btn block color="accent" flat @click="close_form" to="/orders">
                                <v-icon left>receipt</v-icon>
                                В архив заказов
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_send_mail" width="300" persistent>
            <v-card>
                <v-card-title class="subheading accent lighten-3" primary-title>
                    <v-icon left>help_outline</v-icon>
                    <span class="font-weight-medium">Требуется подтверждение</span>
                </v-card-title>
                <v-card-text>
                    <span>Заказ будет отправлен менеджеру для обработки.</span>
                    <v-divider></v-divider>
                    <span class="caption">Позиций: {{order_items.length}}</span>
                    <br />
                    <span class="caption">Штук: {{order_total_QTY}}</span>
                    <br />
                    <span class="caption"><b>Сумма: {{order.total | TO_PRICE }}</b></span>
                    <v-divider></v-divider>
                    Продолжить?
                </v-card-text>
                <v-card-actions class="bg_navbar">
                    <v-layout row wrap>
                        <v-flex xs12 md6>
                            <v-btn block color="secondary" flat @click="dialog_send_mail = false">
                                Отмена
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-btn block color="accent" flat @click="patch_order_status_send_mail(true)">
                                Отправить
                                <v-icon right>send</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <vue-easy-lightbox style="z-index: 9999999"
                               :visible="image_show_fsize"
                               :imgs="image_show_path"
                               @hide="lb_close_image"
            >
            </vue-easy-lightbox>
            <v-card>
                <v-toolbar fixed color="bg_navbar" height="40px">
                    <v-toolbar-title class="hidden-xs-only">
                        Заказ: <u>{{order ? order.order_id : ''}}</u> на сумму {{order.total | TO_PRICE}}
                    </v-toolbar-title>
                    <v-toolbar-title class="hidden-sm-and-up">
                        Заказ
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark flat class="primary bg_navbar--text"
                               :disabled="order_items.length === 0" @click=dialog_show_send_order>
                            <span class="header">Отправить</span>
                            <v-icon right>send</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                    <v-btn icon @click="dialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-container grid-list-md class="mt-3">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-sheet class="ma-2 pa-2">
                                <p>Заказ №: <span class="font-weight-medium">{{order.order_id ? order.order_id : 'не создан'}}</span></p>
                                <p>Позиций: <span class="font-weight-medium">{{order_items.length}}</span></p>
                                <p>Общее количество: <span class="font-weight-medium">{{order_total_QTY}}</span> шт.</p>
                                <v-divider></v-divider>
                                <p>Итого: <span class="font-weight-medium primary--text">{{order.total | TO_PRICE}}</span></p>
                            </v-sheet>
                        </v-flex>
                        <v-flex xs12>
                            <v-textarea class="ma-1 pa-1" name="input-commentary"
                                        label="Комментарий к заказу" v-model="order.commentary"
                                        hint="Не забудьте сохранить"
                                        :disabled="!order"
                                        :rules="[rules.length(1024)]" counter="1024"
                                        outline auto-grow rows="3"
                            >
                                <template slot="append">
                                    <v-btn class="primary--text hidden-sm-and-down"
                                           @click="patch_order_commentary"
                                           outline small flat>
                                        <v-icon small>save</v-icon>
                                        <span>Сохранить</span>
                                    </v-btn>
                                    <v-btn class="primary--text hidden-md-and-up"
                                           @click="patch_order_commentary"
                                           outline small flat icon>
                                        <v-icon small>save</v-icon>
                                    </v-btn>
                                </template>
                            </v-textarea>

                            <v-card-title class="pa-2">
                                <v-layout row wrap align-center justify-space-between fill-height>
                                    <v-flex grow>
                                        <v-text-field class="hidden-sm-and-down"
                                                v-model="search"
                                                label="Поиск по заказу" single-line hide-details
                                                prepend-icon="search"
                                                clearable clear-icon="backspace"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex shrink>
                                        <v-dialog v-model="dialog_delete_confirm" width="300">
                                            <v-btn slot="activator"
                                                   :disabled="selected_rows.length === 0"
                                                   flat>
                                                <span>Удалить выбранные</span>
                                                <v-badge :color="selected_rows.length > 0 ? 'primary' : 'info'">
                                                    <span slot="badge">{{selected_rows.length}}</span>
                                                    <v-icon class="primary--text">restore_from_trash</v-icon>
                                                </v-badge>
                                            </v-btn>
                                            <v-card>
                                                <v-card-title class="subheading primary lighten-4" primary-title>
                                                    <v-icon left>help_outline</v-icon>
                                                    Требуется подтверждение
                                                </v-card-title>
                                                <v-card-text>
                                                    Удалить выбранные: <b>{{selected_rows.length}}</b> позиции из
                                                    заказа?
                                                </v-card-text>
                                                <v-card-actions>
                                                    <v-btn color="secondary" flat
                                                           @click="dialog_delete_confirm = false">
                                                        Отмена
                                                    </v-btn>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="primary" flat
                                                           @click="delete_items_from_cart(selected_rows)">
                                                        Подтвердить
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>
                            <v-container class="pa-2">

                                <div class="hidden-sm-and-down">
                                    <v-data-table
                                            v-model="selected_rows" select-all
                                            :headers="headers" :items="order_items" :search="search"
                                            item-key="id" :pagination.sync="pagination"
                                            :rows-per-page-items="rows_per_page" rows-per-page-text="Товаров на стр."
                                            :expand="row_expanded" class="elevation-1"
                                    >
                                        <template slot="headers" slot-scope="props">
                                            <tr>
                                                <template v-for="header in props.headers">
                                                    <template v-if="header.selected">
                                                        <th v-if="header.sortable" :key="header.text"
                                                            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.sort_value === pagination.sortBy ? 'active' : '']"
                                                            @click="change_sort(header.sort_value)">
                                                            <v-icon small>arrow_upward</v-icon>
                                                            {{ header.text }}
                                                        </th>
                                                        <th v-else class="column" :key="header.text">
                                                            {{ header.text }}
                                                        </th>
                                                    </template>
                                                </template>
                                                <th class="column">
                                                    <v-checkbox
                                                            :input-value="props.all"
                                                            :indeterminate="props.indeterminate"
                                                            primary color="primary" hide-details
                                                            @click.stop="table_toggle_all"
                                                    ></v-checkbox>
                                                </th>
                                            </tr>
                                        </template>

                                        <template slot="items" slot-scope="props">
                                            <tr>
                                                <td @click="props.expanded = !props.expanded">{{ props.item.item.name }}</td>
                                                <td @click="props.expanded = !props.expanded">{{ props.item.item.article }}</td>
                                                <td>
                                                    <v-img style="cursor: pointer;"
                                                           @click="lb_view_image(props.item.item.image_path)"
                                                           contain width="100px" max-height="100px"
                                                           :src="props.item.item.image_path">
                                                        <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                                                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                                        </v-layout>
                                                    </v-img>
                                                </td>
                                                <td @click="props.expanded = !props.expanded">{{ props.item.item.name_brand }}</td>
                                                <td>
                                                    <v-edit-dialog
                                                        large lazy
                                                        @open="open_item_to_cart(props.item.quantity)"
                                                        @save="save_item_to_cart(props.item, order_item_new_qty)"
                                                        cancel-text="Отмена"
                                                        save-text="Изменить"
                                                    >
                                                        <v-btn flat class="accent--text body-2">
                                                            {{ props.item.quantity }}
                                                        </v-btn>
                                                        <div slot="input" class="mt-3 title">Новое количество</div>
                                                        <v-text-field
                                                                slot="input" v-model.number="order_item_new_qty" min="1" step="10"
                                                                label="QTY" single-line autofokus
                                                                append-outer-icon="add_circle_outline"
                                                                @click:append-outer="order_item_new_qty+=1"
                                                                prepend-icon="remove_circle_outline"
                                                                @click:prepend="[order_item_new_qty > 1 ? order_item_new_qty-=1 : order_item_new_qty=1]"
                                                                suffix="шт." type="number"
                                                                v-on:keyup.enter="save_item_to_cart(props.item, order_item_new_qty)"
                                                        ></v-text-field>
                                                        <div slot="input" class="mt-3 subheading">
                                                            Стоимость: <b>{{order_item_new_qty * props.item.price | TO_PRICE}}</b>
                                                        </div>
                                                    </v-edit-dialog>
                                                </td>
                                                <td @click="props.expanded = !props.expanded" class="text-xs-right">{{ props.item.price }}</td>
                                                <td @click="props.expanded = !props.expanded" class="text-xs-right">
                                                    <b>{{ props.item.total }}</b>
                                                </td>
                                                <td :active="props.selected" @click="props.selected = !props.selected">
                                                    <v-checkbox
                                                            :input-value="props.selected"
                                                            primary color="primary"
                                                            hide-details
                                                    ></v-checkbox>
                                                </td>
                                            </tr>
                                        </template>
                                        <template slot="expand" slot-scope="props">
                                            <v-card flat class="info lighten-2">
                                                <v-card-text>
                                                    <v-layout row>
                                                        <v-flex xs1 md1 align-self-center>
                                                            <v-icon>keyboard_capslock</v-icon>
                                                        </v-flex>
                                                        <v-flex xs2 md2 align-self-center>
                                                            Каталог: <b>{{props.item.item.id_parent.name}}</b>
                                                        </v-flex>
                                                        <v-divider vertical></v-divider>
                                                        <v-flex xs7 md7 align-self-center>{{props.item.item.description}}</v-flex>
                                                        <v-divider vertical></v-divider>
                                                        <v-flex xs2 md2 align-self-center style="font-family: monospace;">
                                                            Штук в кор.: {{props.item.item.package_qty}}
                                                            <br/>
                                                            ШК шт. : {{props.item.item.sku_pcs}}
                                                            <br/>
                                                            ШК кор.: {{props.item.item.sku_pkg}}
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card-text>
                                            </v-card>
                                        </template>
                                        <v-alert outline slot="no-results" :value="true" color="error" icon="warning">
                                            По запросу <b>"{{ search }}"</b> ничего не найдено.
                                        </v-alert>
                                        <v-alert outline slot="no-data" :value="true" color="primary" icon="priority_high">
                                            Вы еще ничего не добавили в заказ.
                                        </v-alert>
                                    </v-data-table>
                                </div>

                                <div class="hidden-md-and-up">
                                    <v-data-iterator content-tag="v-layout" row wrap
                                            v-model="selected_rows" select-all
                                            :items="order_items" :search="search"
                                            item-key="id" :pagination.sync="pagination"
                                            :rows-per-page-items="rows_per_page" rows-per-page-text="Товаров на стр."
                                            class="elevation-1"
                                    >
        <template slot="header">
            <v-layout row align-center justify-space-between mx-2>
                <v-flex xs10>
                    <v-select :items="mob_sort_list" label="Сортировать по:"
                              v-model="pagination.sortBy">
                    </v-select>
                </v-flex>
                <v-flex xs2>
                    <v-checkbox v-model="pagination.descending"
                                color="primary"
                                :true-value="false"
                                :false-value="true"
                                on-icon="trending_up"
                                off-icon="trending_down"
                    ></v-checkbox>
                </v-flex>
            </v-layout>
        </template>

        <template slot="item" slot-scope="props">
            <v-flex xs12 sm6 md4 lg3>
                <v-card>
                    <v-card-title class="mob_item_title mob_item_title_text--text mob-s-item-title">
                        <v-layout row wrap align-center justify-space-between>
                            <v-flex xs8>
                                <span class="body-1 font-weight-bold">{{ props.item.item.article }}</span>
                            </v-flex>
                            <v-flex xs2 v-if="is_logged_in">
                                <v-edit-dialog
                                        large lazy
                                        @open="open_item_to_cart(props.item.quantity)"
                                        @save="save_item_to_cart(props.item, order_item_new_qty)"
                                        cancel-text="Отмена"
                                        save-text="Изменить"
                                >
                                    <v-btn class="btn-mini mob_item_title_text--text"
                                           flat icon fab small>
                                        <v-icon medium>exposure</v-icon>
                                    </v-btn>
                                    <div slot="input" class="mt-3 title">Новое количество</div>
                                    <v-text-field
                                            slot="input" v-model.number="order_item_new_qty" min="1" step="10"
                                            label="QTY" single-line autofokus
                                            append-outer-icon="add_circle_outline"
                                            @click:append-outer="order_item_new_qty+=1"
                                            prepend-icon="remove_circle_outline"
                                            @click:prepend="[order_item_new_qty > 1 ? order_item_new_qty-=1 : order_item_new_qty=1]"
                                            suffix="шт." type="number"
                                            v-on:keyup.enter="save_item_to_cart(props.item, order_item_new_qty)"
                                    ></v-text-field>
                                    <div slot="input" class="mt-3 subheading">
                                        Стоимость: <b>{{order_item_new_qty * props.item.price | TO_PRICE}}</b>
                                    </div>
                                </v-edit-dialog>
                            </v-flex>
                            <v-flex xs2 align-center pl-3
                                    :active="props.selected"
                                    @click="props.selected = !props.selected">
                                <v-checkbox dark :input-value="props.selected"
                                            style="margin-top: 0px; padding-top: 0px;"
                                            color="mob_item_btn_in_cart"
                                            hide-details
                                            on-icon="delete"
                                            off-icon="delete_outline"
                                ></v-checkbox>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-divider></v-divider>
                    <p v-if="props.item.item.category_new || props.item.item.category_promo || props.item.item.category_sale"
                       class="ml-3 mt-2"
                       style="margin-bottom: 0px;">
                        <span v-if="props.item.item.category_new"
                              class="primary--text">[NEW] </span>
                        <span v-if="props.item.item.category_promo"
                              class="accent--text">[АКЦИЯ] </span>
                        <span v-if="props.item.item.category_sale"
                              class="success--text text--darken-1">[SALE] </span>
                    </p>
                    <p class="ml-3 mt-2" style="margin-bottom: 0px">
                        {{ props.item.item.name }}
                    </p>
                    <v-divider></v-divider>
                    <v-flex layout style="min-height: 50px; max-height: 120px">
                        <v-img style="cursor: pointer;"
                               @click="lb_view_image(props.item.item.image_path)"
                               contain
                               :src="props.item.item.image_path">
                            <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-layout>
                        </v-img>
                    </v-flex>
                    <v-divider></v-divider>
                    <v-list dense>
                        <v-list-tile>
                            <v-list-tile-content>Брэнд:</v-list-tile-content>
                            <v-list-tile-content class="align-end">{{ props.item.item.name_brand }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-content>Цена:</v-list-tile-content>
                            <v-list-tile-content class="align-end accent--text body-2">{{ props.item.price | TO_PRICE }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-content>Количество:</v-list-tile-content>
                            <v-list-tile-content class="align-end">{{ props.item.quantity }}</v-list-tile-content>
                        </v-list-tile>
                        <v-divider></v-divider>
                        <v-list-tile>
                            <v-list-tile-content>Сумма:</v-list-tile-content>
                            <v-list-tile-content class="align-end font-weight-bold">{{ props.item.total | TO_PRICE }}</v-list-tile-content>
                        </v-list-tile>
                        <v-expansion-panel>
                            <v-expansion-panel-content class="grey lighten-2">
                                <template v-slot:header>
                                    <span class="body-1">Дополнительно</span>
                                </template>
                                <v-card flat class="grey lighten-4">
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <v-flex xs12 align-self-center>
                                                <span class="font-weight-bold">Каталог:</span>
                                                {{props.item.item.id_parent.name}}
                                            </v-flex>
                                            <v-divider style="border: 1px solid #90A4AE;"></v-divider>
                                            <v-flex xs12 align-self-center style="font-family: monospace;">
                                                Штук в кор.: {{props.item.item.package_qty}}
                                                <br/>
                                                ШК шт. : {{props.item.item.sku_pcs}}
                                                <br/>
                                                ШК кор.: {{props.item.item.sku_pkg}}
                                            </v-flex>
                                            <v-divider style="border: 1px solid #90A4AE;"></v-divider>
                                            <v-flex xs12 align-self-center>
                                                <span class="font-weight-bold">Описание:</span>
                                                {{props.item.item.description}}
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-list>
                </v-card>
            </v-flex>
        </template>

        <v-alert class="mx-2" outline slot="no-results" :value="true" color="error" icon="warning">
            По запросу <b>"{{ search }}"</b> ничего не найдено.
        </v-alert>
        <v-alert class="mx-2" outline slot="no-data" :value="true" color="primary" icon="priority_high">
            Вы еще ничего не добавили в заказ.
        </v-alert>

                                    </v-data-iterator>
                                </div>

                            </v-container>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-snackbar v-model="snack" :timeout="6000" :color="snackColor">
                    {{ snackText }}
                    <v-btn flat @click="snack = false" :ripple="false">Закрыть</v-btn>
                </v-snackbar>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import $ from 'jquery';
    import { Globals } from '@/globals.js';
    export default {
        name: "Order",
        data() {
            return {
                dialog: false,
                // Table
                selected_rows: [],
                headers: [
                    {selected: true, sortable: true, text: 'Наименование', align: 'left', value: 'item.name', sort_value: 'item.name' },
                    {selected: true, sortable: true, text: 'Артикул', align: 'left', value: 'item.article', sort_value: 'item.article' },
                    {selected: true, sortable: false, text: 'Картинка', align: 'left', value: 'item.image_path', sort_value: 'item.image_path' },
                    {selected: false, sortable: false, text: 'Описание', align: 'left', value: 'item.description', sort_value: 'item.description' },
                    {selected: true, sortable: true, text: 'Брэнд', align: 'center', value: 'item.name_brand', sort_value: 'item.name_brand' },
                    {selected: true, sortable: true, text: 'Количество', align: 'right', value: 'quantity', sort_value: 'quantity' },
                    {selected: true, sortable: true, text: 'Цена', align: 'right', value: 'price', sort_value: 'price' },
                    {selected: true, sortable: true, text: 'Всего', align: 'right', value: 'total', sort_value: 'total' },
                ],
                rows_per_page: [10, 25, 50, 100, 250, 500],
                row_expanded: true,
                pagination: {
                    descending: false,
                    sortBy: 'name',
                    rowsPerPage: 10,
                    selected_page: 1
                },
                search: '',
                sort: {
                    name: '',
                    order: 'asc'
                },
                mob_sort_list: [
                    {value: 'item.name', text: 'Наименование'},
                    {value: 'item.article', text: 'Артикул'},
                    {value: 'item.name_brand', text: 'Брэнд'},
                    {value: 'price', text: 'Цена'},
                    {value: 'quantity', text: 'Количество'},
                ],
                rules: {
                    length: len => v => (v || '').length < len || `Слишком большое сообщение. Максимум ${len} символов.`,
                },
                // PATCH Order price
                order_item_selected_id: 0,
                order_item_new_qty: 0,
                // DELETE
                dialog_delete_confirm: false,
                delete_success_count: 0,
                delete_error_count: 0,
                // SEND
                dialog_send_mail: false,
                dialog_mail_sent: false,
                // Lightbox
                image_show_fsize: false,
                image_show_path: '',
                // Snack-bar
                snack: false,
                snackColor: '',
                snackText: '',
            }
        },
        created() {
            if (sessionStorage.getItem('auth_token')) {
                $.ajaxSetup({
                    headers: {'Authorization': 'Token ' + sessionStorage.getItem('auth_token')},
                });
            }
            this.$store.dispatch('order_info_init');
            //this.order = this.$store.getters.order_info_get;
            //this.order_items = this.$store.getters.order_goods_get;
        },
        computed: {
            is_logged_in() { return this.$store.getters.logged_state },
            order() { return this.$store.getters.order_info_get },
            order_items() { return this.$store.getters.order_goods_get },
            order_total_QTY() { return this.$store.getters.order_total_qty_get },
        },
        methods: {
            open_item_to_cart(current_order_qty) {
                this.order_item_new_qty = current_order_qty;
            },
            save_item_to_cart(item, qty) {
                if (qty < 1) {
                    this.show_snack('error', 'Некорректное количество');
                    return;
                }
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.MAIN + 'post/orderitems/' + item.id + '/',
                    type: 'PATCH',
                    data: {
                        quantity: qty,
                    },
                    success: () => {
                        this.show_snack('success', 'Количество изменено');
                        this.$store.dispatch('order_info_init');
                    },
                    error: (response) => {
                        this.show_snack('error', 'Ошибка: ' + response.responseJSON.detail);
                    },
                })
            },
            delete_items_from_cart(objs) {
                this.dialog_delete_confirm = false;
                this.selected_rows = [];
                if (objs.length === 0){
                    this.show_snack('error', 'Ничего не выбрано');
                    return;
                }
                this.delete_success_count = 0;
                this.delete_error_count = 0;
                for (let index = 0; index < objs.length; index++){
                    this.delete_item_from_cart(objs[index].id, objs.length)
                }
            },
            delete_item_from_cart(item_id, total_length) {
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.MAIN + 'post/orderitems/' + item_id + '/',
                    type: 'DELETE',
                    data: {
                    },
                    success: () => {
                        this.delete_success_count++;
                    },
                    error: () => {
                        this.delete_error_count++;
                    },
                    complete: () => {
                        if (this.delete_success_count + this.delete_error_count === total_length){
                            this.delete_item_from_cart_complete();
                        }
                    },
                })
            },
            delete_item_from_cart_complete() {
                if (this.delete_error_count > 0)
                    this.show_snack('warning', 'Удалено: ' + this.delete_success_count + ' / Ошибок: ' + this.delete_error_count);
                else
                    this.show_snack('success', 'Удалено: ' + this.delete_success_count + ' / Ошибок: ' + this.delete_error_count);
                this.$store.dispatch('order_info_init');
            },
            patch_order_commentary() {
                if (!this.order.id) {
                    this.show_snack('error', 'Нет активного заказа. Попробуйте добавить что-нибудь в корзину.');
                    return;
                }
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.MAIN + 'post/orders/' + this.order.id + '/',
                    type: 'PATCH',
                    data: {
                        commentary: this.order.commentary,
                    },
                    success: () => {
                        this.show_snack('success', 'Комментарий изменен');
                        this.$store.dispatch('order_info_init');
                    },
                    error: (response) => {
                        this.show_snack('error', 'Ошибка: ' + response.responseJSON.detail);
                    },
                })
            },
            patch_order_status_send_mail(perform_send) {
                this.dialog_send_mail = false;
                if (!this.order.id) {
                    this.show_snack('error', 'Нет активного заказа. Попробуйте добавить что-нибудь в корзину.');
                    return;
                }
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.MAIN + 'post/orders/' + this.order.id + '/',
                    type: 'PATCH',
                    data: {
                        perform_send: perform_send,
                        status: 2,
                        commentary: this.order.commentary,
                    },
                    success: () => {
                        this.show_snack('success', 'Заказ отправлен и перемещен в архив');
                        this.$store.dispatch('order_info_init');
                        this.dialog_mail_sent = true;
                    },
                    error: (response) => {
                        this.show_snack('error', 'Ошибка: ' + response.responseJSON.detail);
                    },
                })
            },
            // Table
            change_sort(column) {
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column;
                    this.pagination.descending = false
                }
            },
            table_toggle_all() {
                if (this.selected_rows.length > 0)
                    this.selected_rows = [];
                else
                    this.selected_rows = this.order_items.slice();
            },
            // Lightbox
            lb_view_image(image_path){
                this.image_show_fsize = true;
                this.image_show_path = image_path;
            },
            lb_close_image(){
                this.image_show_fsize = false;
                this.image_show_path = '';
            },
            // Form MISC
            show_snack(snack_color, snack_text){
                this.snack = true;
                this.snackColor = snack_color;
                this.snackText = snack_text;
            },
            close_form() {
                this.dialog_mail_sent = false;
                this.dialog_send_mail = false;
                this.dialog_delete_confirm = false;
                this.dialog = false;
            },
            dialog_show_send_order() {
                this.patch_order_commentary();
                this.dialog_send_mail = true;
            },
        },
        filters: {
            TO_PRICE(value) {
                if(value)
                    return `₽ ${value.toLocaleString()}`;
                else
                    return "--";
            }
        },
    }
</script>

<style scoped>

</style>